import React, { Component } from "react";
import "./css/aboutme.css";
import { API_BASE_URL, authHeaders } from "../api";

class Aboutme extends Component {
    state = {}

    componentDidMount() {
        this.getAboutMe();
    }

    phone = () => {
        const phone = this.state.aboutMe?.contact?.phone;
        if (phone) window.open(`tel:${phone}`);
    }

    mail = () => {
        const mail = this.state.aboutMe?.contact?.mail;
        if (mail) window.open(`mailto:${mail}`);
    }

    getAboutMe = async () => {

        const response = await fetch(`${API_BASE_URL}/api/aboutme`, {
            headers: authHeaders()
        });
        try {

            const data = await response.json();

            this.setState({ aboutMe: data });

            console.log(data);
        } catch (error) {
            console.error("Fehler beim Abrufen der About Me Daten:", error);
        }
    };

    render() {
        return (
            <React.Fragment>
            <div className="divider" id="about-me">
              <span>Über Mich</span>
            </div>
            <div className="aboutme-feat">
                
                <div className="section" id="abt-me-section">

                    <h3 className="abt-me-header">Über mich</h3>
                    <p>
                        {
                            this.state.aboutMe?.aboutme?.first ? (
                                this.state.aboutMe.aboutme.first
                            ) : (
                                <p className="card-text placeholder-glow">
                                    <span className="placeholder col-7"></span>
                                    <span className="placeholder col-4"></span>
                                    <span className="placeholder col-4"></span>
                                    <span className="placeholder col-6"></span>
                                    <span className="placeholder col-8"></span>
                                    <span className="placeholder col-4"></span>
                                    <span className="placeholder col-8"></span>
                                    <span className="placeholder col-7"></span>
                                    <span className="placeholder col-8"></span>
                                </p>
                            )
                        }<br /><br />
                        {
                            this.state.aboutMe?.aboutme?.secand ? (
                                this.state.aboutMe.aboutme.secand
                            ) : (
                                <p className="card-text placeholder-glow">
                                    <span className="placeholder col-7"></span>
                                    <span className="placeholder col-4"></span>
                                    <span className="placeholder col-4"></span>
                                    <span className="placeholder col-6"></span>
                                    <span className="placeholder col-8"></span>
                                    <span className="placeholder col-4"></span>
                                    <span className="placeholder col-8"></span>
                                    <span className="placeholder col-7"></span>
                                </p>
                            )
                        }
                        <br /><br />
                        {
                            this.state.aboutMe?.aboutme?.third ? (
                                this.state.aboutMe.aboutme.third
                            ) : (
                                <p className="card-text placeholder-glow">
                                    <span className="placeholder col-7"></span>
                                    <span className="placeholder col-4"></span>
                                    <span className="placeholder col-4"></span>
                                    <span className="placeholder col-6"></span>
                                    <span className="placeholder col-8"></span>
                                </p>
                            )
                        }
                    </p>

                </div>

                <div className="section image-section">
                    <img className="james-img" src="./assets/img/Schreiber_Bew1-4661_A5_sRGB.jpg" alt="About Me" />
                </div>

                <div className="section">
                    <h3>Erfahrungen:</h3>
                    <p>
                        {
                            this.state.aboutMe?.knollage?.experice ? (
                                this.state.aboutMe.knollage.experice
                            ) : (
                                <p className="card-text placeholder-glow">
                                    <span className="placeholder col-7"></span>
                                    <span className="placeholder col-4"></span>
                                    <span className="placeholder col-4"></span>
                                    <span className="placeholder col-6"></span>
                                    <span className="placeholder col-8"></span>
                                    <span className="placeholder col-7"></span>
                                    <span className="placeholder col-4"></span>
                                    <span className="placeholder col-4"></span>
                                    <span className="placeholder col-6"></span>
                                    <span className="placeholder col-8"></span>                      
                                    <span className="placeholder col-4"></span>
                                    <span className="placeholder col-4"></span>
                                    <span className="placeholder col-6"></span>
                                    <span className="placeholder col-8"></span>
                                </p>
                            )
                        }
                    </p>
                    <br />
                    <br />
                    <br />
                    <h3>Kontakt:</h3>

                    <div className="contact-info" onClick={this.mail}>
                        E-Mail: <span> {this.state.aboutMe?.contact?.mail ? (this.state.aboutMe?.contact?.mail ):( <span className="placeholder col-8"></span>)} </span>
                    </div>

                    <div className="contact-info" onClick={this.phone}>
                        Telefon: <span>{this.state.aboutMe?.contact?.phone ? (this.state.aboutMe?.contact?.phone ):( <span className="placeholder col-8"></span>)} </span>
                    </div>
                </div>



            </div>
                {/* <a className="scroll-indicator" href="#about-me">
                  <span></span>
                </a> */}
            </React.Fragment>   
        );
    }
}

export default Aboutme;
